/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import React from 'react'
import Button from 'src/components/ts-components/Button'

interface ModalFooterProps {
  onClose: () => void
}

/** Footer component for the ManageTeamAttendance modal */
const ModalFooter: React.FC<ModalFooterProps> = ({ onClose }) => {
  return (
    <div
      css={css`
        display: flex;
        justify-content: flex-end;
        gap: 16px;
        width: 25%;
        margin-left: auto;
      `}
    >
      <Button text='Close' onClick={onClose} variant='secondary' />
    </div>
  )
}

export default React.memo(ModalFooter)
